export const routes = [
  {
    route: 'HOME',
    breadcrumbs: [],
    title: 'Početna'
  },

  {
    route: 'TER_NARUDZBE',
    breadcrumbs: ['TER_NARUDZBE'],
    title: 'Projekti'
  },
  {
    route: 'EDITOR',
    breadcrumbs: ['HOME'],
    title: 'Tehnička priprema'
  },
  {
    route: 'IMPORT',
    breadcrumbs: ['HOME'],
    title: 'Import'
  },
  {
    route: 'IMPORTOSTALO',
    breadcrumbs: ['HOME'],
    title: 'Import/Export ostalo...'
  },
  {
    route: 'EXPORT',
    breadcrumbs: ['HOME'],
    title: 'Export'
  },
  {
    route: 'EXPORT_CNC',
    breadcrumbs: ['EXPORT_CNC'],
    title: 'CNC Export'
  },
  {
    route: 'BIBLIOTEKA',
    breadcrumbs: ['HOME'],
    title: 'Biblioteka genusa',
    menuOptionTree: 'BIBLIOTEKA_GROUP',
  },
  {
    route: 'BIBLIOTEKA_PARAMETARA',
    breadcrumbs: ['HOME'],
    title: 'Biblioteka parametara',
    menuOptionTree: 'BIBLIOTEKA_GROUP',
  },
  {
    route: 'BIBLIOTEKA_POLJA',
    breadcrumbs: ['HOME'],
    title: 'Biblioteka polja',
    menuOptionTree: 'BIBLIOTEKA_GROUP',
  },


  // DOCS
  {
    route: 'DOKUMENTACIJA',
    breadcrumbs: ['HOME'],
    title: 'Dokumentacija',
    menuOptionTree: 'DOKUMENTACIJA_GROUP'
  },
  {
    route: 'DOKUMENTACIJA_UPUTSTVO',
    breadcrumbs: ['HOME'],
    title: 'Uputstvo za korisnike',
    menuOptionTree: 'DOKUMENTACIJA_GROUP'
  },
  {
    route: 'DOKUMENTACIJA_TERMOVENT',
    breadcrumbs: ['HOME'],
    title: 'Dokumentacija Termovent',
    menuOptionTree: 'DOKUMENTACIJA_GROUP'
  },
  {
    route: 'DOKUMENTACIJA_TESTIRANJE',
    breadcrumbs: ['HOME'],
    title: 'Dokumentacija Testiranje',
    menuOptionTree: 'DOKUMENTACIJA_GROUP'
  },
  {
    route: 'DOKUMENTACIJA_U_RAZVOJU',
    breadcrumbs: ['HOME'],
    title: 'Dokumentacija u razvoju',
    menuOptionTree: 'DOKUMENTACIJA_GROUP'
  },
  {
    route: 'DOCS_STANDARDI',
    breadcrumbs: ['HOME'],
    title: 'Standardi'
  },
  {
    route: 'PREZENTACIJA',
    breadcrumbs: ['HOME'],
    title: 'Prezentacija',
    menuOptionTree: 'PREZENTACIJA_GROUP'
  },
  {
    route: 'PREZENTACIJA2',
    breadcrumbs: ['HOME'],
    title: 'Prezentacija2',
    menuOptionTree: 'PREZENTACIJA_GROUP'
  },
  {
    route: 'PREZENTACIJA2022',
    breadcrumbs: ['HOME'],
    title: 'Prezentacija 2022',
    menuOptionTree: 'PREZENTACIJA_GROUP'
  },
  {
    route: 'PRIMERI',
    breadcrumbs: ['PRIMERI'],
    title: 'Primeri'
  },
  {
    route: 'PLAN',
    breadcrumbs: ['HOME'],
    title: 'Plan'
  },


  // ADMIN PANEL
  {
    route: 'ADMIN_PANEL',
    breadcrumbs: ['HOME'],
    title: 'Admin Panel',
    second_screen: true,
  },
  {
    route: 'ADMIN_USERS',
    breadcrumbs: ['HOME', 'ADMIN_PANEL'],
    title: 'Admin Panel Korisnici',
    second_screen: true,
  },
  {
    route: 'ADMIN_TER_COMORDER',
    breadcrumbs: ['HOME', 'ADMIN_PANEL'],
    title: 'Admin Panel Narudzbe',
    second_screen: true,
  },
  {
    route: 'ADMIN_TER_COMORDITEM',
    breadcrumbs: ['HOME', 'ADMIN_PANEL'],
    title: 'Admin Panel Stavke Narudžbe',
    second_screen: true,
  },
  {
    route: 'ADMIN_DINAMICKAF',
    breadcrumbs: ['HOME', 'ADMIN_PANEL'],
    title: 'Admin Panel Dinamička Funkcionalnost',
    second_screen: true,
  },
  {
    route: 'ADMIN_RADNICENTRI',
    breadcrumbs: ['HOME', 'ADMIN_PANEL'],
    title: 'Admin Panel Radni Centri',
    second_screen: true,
  },
  {
    route: 'ADMIN_LIB_CPARAMS',
    breadcrumbs: ['HOME', 'ADMIN_PANEL'],
    title: 'Admin Panel Biblioteka default cparams',
    second_screen: true,
  },
  {
    route: 'ADMIN_LIB_VIRTEL_PARAMS',
    breadcrumbs: ['HOME', 'ADMIN_PANEL'],
    title: 'Admin Panel Biblioteka Virtel Params',
    second_screen: true,
  },
  {
    route: 'ADMIN_LIB_MATERIJAL_LIM',
    breadcrumbs: ['HOME', 'ADMIN_PANEL'],
    title: 'Admin Panel Biblioteka Materijal Lim',
    second_screen: true,
  },
  {
    route: 'ADMIN_LIB_CNC_S4_TEMPLATE',
    breadcrumbs: ['HOME', 'ADMIN_PANEL'],
    title: 'Admin Panel CNC Programi',
    second_screen: true,
  },
  {
    route: 'ADMIN_LIB_DOCUMENT',
    breadcrumbs: ['HOME', 'ADMIN_PANEL'],
    title: 'Admin Panel Biblioteka Tabela',
    second_screen: true,
  },
  {
    route: 'ADMIN_LIB_TER_CONST',
    breadcrumbs: ['HOME', 'ADMIN_PANEL'],
    title: 'Admin Panel Biblioteka Termovent Konstanti',
    second_screen: true,
  },

  // TODO
  {
    route: 'TEMP_CNC_OPTIMIZACIJE',
    breadcrumbs: ['HOME', 'ADMIN_PANEL'],
    title: '* Temp. Optimizacije',
    second_screen: true,
  },


  // DEV
  {
    route: 'DEVPANEL',
    breadcrumbs: ['HOME'],
    title: 'Dev Panel'
  },
];


//
export const routeDataGet = (route) => {
  let targetRoute = {
    route: 'NOTFOUND',
    breadcrumbs: [],
    title: 'not found',
    is_admin_panel: false,
  };
  routes.forEach((r) => {
    if (r.route === route) {
      targetRoute = r;
      if (targetRoute.is_admin_panel !== true) {
        targetRoute.is_admin_panel = false;
      }
      if (r.menuOptionTree) {
        targetRoute.menuOptionTree = r.menuOptionTree;
      }
      if (r.second_screen === true) {
        targetRoute.second_screen = true;
      }
    }
  });
  return targetRoute;
};

// export { routes, routeDataGet };